import Section from '../containers/Section'
import ContactDetailsSection from '../contacts/ContactDetailsSection'
import ContactAddressesSection from '../contacts/ContactAddressesSection'
import LockedMark from '../contacts/LockedMark'
import { withFlag } from '../contacts/contactLists'
import useMarketingDecision, { withDecision } from '../consent/useMarketingDecision'

export default function FirmContactSettings({
    detailsList,
    addressesList,
    locked,
    consentPathOf,
    busy,
}) {
    const storeDetailFlagChange = async (id, key, wanted) => {
        const detail = detailsList.items.find((item) => item.id === id)
        const flags = withFlag(detail?.flags, key, wanted)
        const outcome = await detailsList.update(id, { flags })

        if (outcome.refused != null) {
            throw outcome.refused
        }
    }

    const applyDecision = (decided) => {
        detailsList.setItems((current) => withDecision(current, decided))
    }

    const {
        onFlagChange: handleDetailFlagChange,
        dialog: marketingConsentDialog,
        deciding,
    } = useMarketingDecision({
        details: detailsList.items,
        consentPathOf,
        onDecided: applyDecision,
        onFlagChange: storeDetailFlagChange,
    })

    const updateDetail = ({ id, ...input }) => detailsList.update(id, input)

    const addDetail = (input) => detailsList.create({
        ...input,
        flags: [],
    })

    const updateAddress = ({ id, ...input }) => addressesList.update(id, input)

    const sectionsBusy = busy || deciding

    return (
        <>
            <Section title="כתובות" xs={12}>
                {locked.addresses && <LockedMark testId="contact-addresses-locked" />}
                <ContactAddressesSection
                    addresses={addressesList.items}
                    onAdd={addressesList.create}
                    onUpdate={updateAddress}
                    onRemove={addressesList.remove}
                    onRestore={addressesList.restore}
                    onConfirmRemoval={addressesList.confirmRemoval}
                    refusals={addressesList.refusals}
                    onReorder={addressesList.reorder}
                    disabled={locked.addresses}
                    busy={sectionsBusy}
                />
            </Section>
            <Section title="פרטי קשר" xs={12}>
                {locked.details && <LockedMark testId="contact-details-locked" />}
                <ContactDetailsSection
                    details={detailsList.items}
                    onAdd={addDetail}
                    onUpdate={updateDetail}
                    onRemove={detailsList.remove}
                    onRestore={detailsList.restore}
                    onConfirmRemoval={detailsList.confirmRemoval}
                    refusals={detailsList.refusals}
                    onReorder={detailsList.reorder}
                    onFlagChange={handleDetailFlagChange}
                    flags={['shareable', 'reachable']}
                    disabled={locked.details}
                    busy={sectionsBusy}
                />
                {marketingConsentDialog}
            </Section>
        </>
    )
}
